import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';

import { StyledTableCell } from './TableBasic';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { MessageDelete } from './MessageDelete';
import { urlDeleteClient, urlCreateEstimate, urlCertification, urlProduct, urlUser, urlWorks } from '../helpers';

export const DeleteTableField = ({ keyDelete, tableTitle, rows, setFilterArray, setCopyArray }) => {
    const navigate = useNavigate();
    const [confirmation, setConfirmation] = useState(false);
    const [idData, setIdData] = useState('');
    let dataToDelete;
    switch (tableTitle) {
        case 'client':
            dataToDelete = 'Presupuestos, obras y certificaciones'; break;
        case 'estimate':
            dataToDelete = 'Obras y certificaciones'; break;
        case 'certification':
            dataToDelete = ''; break;
        case 'work':
            dataToDelete = 'Certificaciones'; break;
        default:
            break;
    }

    const handleEdit = () => {
        switch (tableTitle) {
            case 'client':
                navigate(`/editClient?id=${keyDelete}`); break;
            case 'estimate':
                navigate(`/editEstimate?id=${keyDelete}`); break;
            case 'certification':
                navigate(`/editCertification?id=${keyDelete}`); break;
            case 'products':
                navigate(`/editProducts?id=${keyDelete}`); break;
            case 'user':
                navigate(`/editUser?id=${keyDelete}`); break;
            case 'work':
                navigate(`/editWork?id=${keyDelete}`); break;
            default:
                break;
        }

    }

    const handleViewDetails = () => {
        switch (tableTitle) {
            case 'work':
                navigate(`/viewWork?id=${keyDelete}`); break;
            case 'estimate':
                navigate(`/viewEstimate?id=${keyDelete}`); break;
            case 'certification':
                navigate(`/viewCertification?id=${keyDelete}`); break;
            default: break;
        }
    }

    const onConfirm = () => {
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
        let url;
        const key = JSON.stringify({ id: keyDelete });

        if (tableTitle === 'client') {
            url = urlDeleteClient;
        } else if (tableTitle === 'estimate') {
            url = urlCreateEstimate;
        } else if (tableTitle === 'certification') {
            url = urlCertification;
        } else if (tableTitle === 'products') {
            url = urlProduct;
        } else if (tableTitle === 'user') {
            url = urlUser;
        } else if (tableTitle === 'work') {
            url = urlWorks;
        }

        fetch(url, {
            method: 'DELETE',
            body: key,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then(r => r.json())
            .then(d => {
                if (d.status) {
                    setFilterArray(rows.filter(el => el.id !== keyDelete))
                    setCopyArray(rows.filter(el => el.id !== keyDelete))
                }
            })
    }

    const handleClick = () => {
        const data = rows.filter((d) => d.id === keyDelete);
        if (tableTitle === 'client') {
            setIdData(data[0].name);
        } else if (tableTitle === 'estimate') {
            setIdData(data[0].client + ' nº ' + data[0].id)
        } else if (tableTitle === 'certification') {
            setIdData(data[0].name + '  nº ' + data[0].nº)
        } else if (tableTitle === 'products') {
            setIdData(data[0].product)
        } else if (tableTitle === 'user') {
            setIdData(data[0].email)
        } else if (tableTitle === 'work') {
            setIdData(data[0].addressWork)
        }
        setConfirmation(!confirmation);
    }

    const handleBill = () => {
        navigate(`/printEstimate?id=${keyDelete}`)
    }

    return (
        <Fragment>
            <StyledTableCell align="right">
                {(tableTitle !== 'client' && tableTitle !== 'products' && tableTitle !== 'user') &&
                    <IconButton onClick={handleViewDetails}>
                        <PreviewIcon color='primary' />
                    </IconButton>
                }
                {
                    (rows.filter((d) => d.id === keyDelete)[0].status !== 'Aceptado')
                        ?
                        <IconButton color='primary' onClick={handleEdit} >
                            <EditIcon />
                        </IconButton>
                        :
                        <IconButton color='primary' onClick={handleBill} >
                            <ReceiptOutlinedIcon />
                        </IconButton>

                }

                <IconButton color='primary' onClick={handleClick}>
                    <DeleteOutlineIcon />
                </IconButton>
            </StyledTableCell>
            {confirmation && <MessageDelete dataToDelete={dataToDelete} idData={idData} onConfirm={onConfirm} setConfirmation={setConfirmation} />}
        </Fragment>
    )
}
